export const licensePolicyColumns = ["policyName", "globalFlag", "remark"];
export const licensePolicyStepColumns = ["policyStep", "policyStepColor", "licenseUseApprovalCd", "remark"];
export const licensePolicyItemColumns = ["licensePolicyCd"];
export const licensePolicyRuleExceptionColumns = [
  "licenseIdentifier",
  "licenseName",
  "matchTypeCd",
  "modificationFlag",
  "patentFlag",
  "policyStep",
  "policyStepColor",
  "licenseUseApprovalCd",
];

export const columnsLicenseTable = ["licenseIdentifier", "licenseName", "defaultFlag"];

export const columnDisplayNames = {
  // Table Layer 1
  policyName: "license-policy.policy-name",
  globalFlag: "license-policy.default-policy",
  remark: "license-policy.remark",
  // Table Layer 2
  policyStep: "license-policy.policy-step",
  policyStepColor: "license-policy.policy-step-color",
  licenseUseApprovalCd: "license-policy.license-use-approval",
  // Table Layer 3
  licensePolicyCd: "license-policy.license-policy-item",
  description: "license-policy.description",
  // Rule exception list
  licenseIdentifier: "license-policy.license-identifier",
  licenseName: "license-policy.license-name",
  matchTypeCd: "license-policy.match-type-cd-name",
  modificationFlag: "license-policy.modification-flag",
  patentFlag: "license-policy.patent-flag",
};

// Color options for policy steps
export const POLICY_STEP_COLORS = [
  { value: 'black', label: 'Black' },
  { value: 'red', label: 'Red' },
  { value: 'orange', label: 'Orange' },
  { value: 'steelblue', label: 'Steel Blue' },
  { value: 'green', label: 'Green' }
];

export const DUPLICATE_POLICY_NAME_ERROR = "Policy name is duplicated!";
export const DEFAULT_POLICY_EXISTED_ERROR = "Default policy already exists.";
export const VALIDATE_DEFAULT_POLICY_ERROR = "At least one policy must be set as Default Policy (Yes).";

export const getPolicyStepColors = (t) => [
  { value: 'black', label: t('license-policy.colors.black') },
  { value: 'red', label: t('license-policy.colors.red') },
  { value: 'orange', label: t('license-policy.colors.orange') },
  { value: 'steelblue', label: t('license-policy.colors.steelblue') },
  { value: 'green', label: t('license-policy.colors.green') }
];

export const POLICY_APPROVAL_OPTIONS = [
  { value: 'APPROVAL', label: 'Approval' },
  { value: 'DISAPPROVAL', label: 'Disapproval' },
  { value: 'CONDITIONAL_APPROVAL', label: 'Conditional Approval' },
];

export const getPolicyApprovalOptions = (t) => [
  { value: 'APPROVAL', label: t('license-policy.approval') },
  { value: 'DISAPPROVAL', label: t('license-policy.disapproval') },
  { value: 'CONDITIONAL_APPROVAL', label: t('license-policy.conditional-approval') },
];

export const get_policy_attributes = (t) => [
  {
    code: "ATTR_01",
    name: t("license-policy.g_attributes.ATTR_01.name"),
    remark: t("license-policy.g_attributes.ATTR_01.remark"),
    order: 1
  },
  {
    code: "ATTR_02_ALL",
    name: t("license-policy.g_attributes.ATTR_02_ALL.name"),
    remark: t("license-policy.g_attributes.ATTR_02_ALL.remark"),
    order: 2
  },
  {
    code: "ATTR_02_FILE",
    name: t("license-policy.g_attributes.ATTR_02_FILE.name"),
    remark: t("license-policy.g_attributes.ATTR_02_FILE.remark"),
    order: 3
  },
  {
    code: "ATTR_02_LIBRARY",
    name: t("license-policy.g_attributes.ATTR_02_LIBRARY.name"),
    remark: t("license-policy.g_attributes.ATTR_02_LIBRARY.remark"),
    order: 4
  },
  {
    code: "ATTR_02_MODULE",
    name: t("license-policy.g_attributes.ATTR_02_MODULE.name"),
    remark: t("license-policy.g_attributes.ATTR_02_MODULE.remark"),
    order: 5
  },
  {
    code: "ATTR_03",
    name: t("license-policy.g_attributes.ATTR_03.name"),
    remark: t("license-policy.g_attributes.ATTR_03.remark"),
    order: 6
  },
  {
    code: "ATTR_04",
    name: t("license-policy.g_attributes.ATTR_04.name"),
    remark: t("license-policy.g_attributes.ATTR_04.remark"),
    order: 7
  },
  {
    code: "ATTR_05",
    name: t("license-policy.g_attributes.ATTR_05.name"),
    remark: t("license-policy.g_attributes.ATTR_05.remark"),
    order: 8
  },
  {
    code: "ATTR_06",
    name: t("license-policy.g_attributes.ATTR_06.name"),
    remark: t("license-policy.g_attributes.ATTR_06.remark"),
    order: 9
  },
  {
    code: "ATTR_07",
    name: t("license-policy.g_attributes.ATTR_07.name"),
    remark: t("license-policy.g_attributes.ATTR_07.remark"),
    order: 10
  },
  {
    code: "ATTR_08",
    name: t("license-policy.g_attributes.ATTR_08.name"),
    remark: t("license-policy.g_attributes.ATTR_08.remark"),
    order: 11
  },
  {
    code: "ATTR_09",
    name: t("license-policy.g_attributes.ATTR_09.name"),
    remark: t("license-policy.g_attributes.ATTR_09.remark"),
    order: 12
  },
  {
    code: "ATTR_10",
    name: t("license-policy.g_attributes.ATTR_10.name"),
    remark: t("license-policy.g_attributes.ATTR_10.remark"),
    order: 13
  },
  {
    code: "ATTR_11",
    name: t("license-policy.g_attributes.ATTR_11.name"),
    remark: t("license-policy.g_attributes.ATTR_11.remark"),
    order: 14
  },
  {
    code: "ATTR_12",
    name: t("license-policy.g_attributes.ATTR_12.name"),
    remark: t("license-policy.g_attributes.ATTR_12.remark"),
    order: 15
  },
  {
    code: "ATTR_13",
    name: t("license-policy.g_attributes.ATTR_13.name"),
    remark: t("license-policy.g_attributes.ATTR_13.remark"),
    order: 16
  },
];

export const getDefaultFlagOptions = (t) => [
  { value: "Y", label: t("common.yes") },
  { value: "N", label: t("common.no") },
];

// Map values ​​for policyStep, policyStepColor, and licenseUseApprovalCd
export const policyStepMapping = {
  1: { policyStepColor: "black", licenseUseApprovalCd: "DISAPPROVAL" },
  2: { policyStepColor: "red", licenseUseApprovalCd: "DISAPPROVAL" },
  3: { policyStepColor: "orange", licenseUseApprovalCd: "CONDITIONAL_APPROVAL" },
  4: { policyStepColor: "steelblue", licenseUseApprovalCd: "APPROVAL" },
  5: { policyStepColor: "green", licenseUseApprovalCd: "APPROVAL" },
};

export const searchFields = [
  {
    name: "licenseIdentifier",
    label: "license-policy.license-identifier",
    placeholder: "license-policy.license-identifier",
  },
  {
    name: "licenseName",
    label: "license-policy.license-name",
    placeholder: "license-policy.license-name",
  },
  {
    name: "defaultFlag",
    label: "license-policy.default-flag",
    type: "select",
    options: [
      { value: "", label: "Select" },
      { value: "Y", label: "Yes" },
      { value: "N", label: "No" },
    ],
  },
];
